import { modifyState } from '~src/state';
import { updateTextBorderColorControl } from '~core/borders';

export const onTextBorderChangeColor = (event) => {
  event.preventDefault();
  modifyState('setTextBorderColorActive', true);
  updateTextBorderColorControl();
};
